export class LayoutServiceBase {
}
